
export const twitterShareLink = "https://twitter.com/intent/tweet?text=";
export const facebookShareLink = "https://www.facebook.com/dialog/feed?app_id=445815495479697";
export const whatsappShareLink = "https://api.whatsapp.com/send?text=";

export const googleShareLink = "https://plus.google.com/share?url=";

// export const shareableUrl = "https://www.narendramodi.in/diwali2020";
// export const shareableUrl = "https://examwarriorsv2.narendramodi.in";
export const shareableUrl = "https://www.narendramodi.in/examwarriorsv2";

// export const detailsPageBaseUrl = "https://www.narendramodi.in/diwali2020/";
// export const detailsPageBaseUrl = "https://www.narendramodi.in/vivekananda/";
// export const detailsPageBaseUrl = "https://narendramodi.in/vivekanand-jayanti/";
export const detailsPageBaseUrl = "https://www.narendramodi.in/examwarriorsv2/";

export const imgUrl = `https://examwarriorsv2.narendramodi.in`;
export const imgBaseUrl = `https://examwarriorsv2.narendramodi.in`;

export const apiUrl = "https://campaign-api.narendramodi.in/";
// var apiUrl = "https://eyvqtsj8zf.execute-api.ap-south-1.amazonaws.com/NMCampaign/";

export const _token = "U2FsdGVkX1+6xZSquhp+9FRCTowbbo9Qld+FrsBig+6Q3J87AoNH9lY7tx6vzaMWmcUkS+LG2wAbOFJQ9Qy34WrqUnWUy+dVTKQydY2fYVzCBkhjZ/x3tLSMBQxJqJGxzCPh9AP0n2pN9CJ5KZuKKF1XCRIi3C1Q79sXQItY/qcCs7G2oBPaBqhrbP0WrmnDVmbGT6bWCYvoeLFk50boHZdOx9yL80+JbSHuEaxh6qEmkTKEr2rIYsusZcCZEUA7yHNX7QuUY3Vd0F3g6162CHxVHPtBux0kwQqY0/7+2UeXtgwkinwXp3AKM3KYBHT9V+FR1iD2cjlYQK9HebBl3YDgEV3QSDLKWXyOmeFPAbE=";

export const shareDefaultText = "";
export const shareDefaultTextForApp = "";
